export const URLS = {
  renderings: {
    tryItNow: '/signup/professional',
    chatWithUs:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDgnQAG&campaignMedium=Website&campaignSource=Renderings',
    consumerRenderings: 'https://hover.to/renderings/new',
  },
  materialList: {
    reqEarlyAccess: 'https://hover.qualtrics.com/jfe/form/SV_3ymv0DiDO6P4PWe',
  },
  homePage: {
    chatWithARep: 'https://hover.to/lp/hover-sdr/chat-with-a-rep',
  },
  trustedByNames: {
    chatWithARep:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XAduQAG&campaignMedium=Website&campaignSource=Website%20Homepage',
  },
  navBar: {
    chatWithARep: 'https://hover.to/lp/hover-sdr/chat-with-a-rep',
    scheduleDemo: 'https://hover.to/lp/hover-sdr/demo',
  },
  newConstructionSolution: {
    chatWithUs: 'https://hover.to/lp/hover-sdr/new-construction',
    tryItNow: '/signup/professional',
  },
  exteriorHouseDesign: {
    StartFreeTrial: 'https://hover.to/signup',
    chatWithUs:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDgYQAW&campaignMedium=Website&campaignSource=Website',
  },
  insurance: {
    chatWithUs:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDfzQAG&campaignMedium=Website&campaignSource=Hover%20for%20Insurance',
  },
  architects: {
    chatWithUs:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDgEQAW&campaignMedium=Website&campaignSource=Architects%20-%20Website',
  },
  exteriorContractors: {
    chatWithUs:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDg4QAG&campaignMedium=Website&campaignSource=Website%20Exterior%20Contractors',
  },
  sidingEstimates: {
    requestDemo:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000002Fn9kQAC&campaignMedium=&campaignSource=Siding',
    scheduleCall:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000002Fn9kQAC&campaignMedium=&campaignSource=Siding',
  },
  restoration: {
    chatWithUs:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDg4QAG&campaignMedium=Website&campaignSource=Website%20Exterior%20Contractors',
  },
  howToMeasureRoof: {
    chatWithUs:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDg4QAG&campaignMedium=Website&campaignSource=Website%20Exterior%20Contractors',
  },
  directOrdering: {
    scheduleMeeting:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDgiQAG&campaignMedium=Website&campaignSource=Direct%20Ordering',
    learnMore: 'https://help.hover.to/en/collections/2907143-direct-ordering',
    scheduleCall:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDgiQAG&campaignMedium=Website&campaignSource=Direct%20Ordering',
    getSetUp:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDgiQAG&campaignMedium=Website&campaignSource=Direct%20Ordering',
  },
  pricing: {
    scheduleMeeting: 'https://hover.to/lp/hover-sdr/pricing',
    contactSales: 'https://hover.to/lp/hover-sdr/pricing',
    scheduleDemo:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDgJQAW&campaignMedium=Website&campaignSource=Website',
    addAdvancedExports: 'https://hover.to/lp/hover-sdr/3d-exports',
  },
  transformPlan: {
    scheduleDemo:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDgTQAW&campaignMedium=Website&campaignSource=Transform',
  },
  hoverReports: {
    contactSales:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDgJQAW&campaignMedium=Website&campaignSource=Website',
  },
  interiors: {
    chatWithUs:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XIuZQAW&campaignMedium=&campaignSource=Interiors',
    getEarlyAccess: 'https://form.jotform.com/222515716706152',
  },
  vinylSidingEstimator: {
    chatWithUs:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDg4QAG&campaignMedium=Website&campaignSource=Website Vinyl Siding Estimator',
  },
  measurementsOfHouse: {
    chatWithUs:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDg4QAG&campaignMedium=Website&campaignSource=Website Measurements of a House',
  },
  homeownerRenderings: {
    getStarted: 'https://hover.to/renderings/new',
  },
  order: {
    getADemo:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000002GAbSQAW&utm_medium=website&utm_campaign=order_material',
    chatWithARep:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XBK5QAO&utm_medium=website&utm_campaign=website_nav_bar',
  },
  estimateClose: {
    getADemo: 'https://hover.to/lp/hover-sdr/estimates',
    chatWithARep:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XBK5QAO&utm_medium=website&utm_campaign=website_nav_bar',
  },
  measure: {
    getADemo:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000002GAbIQAW&utm_medium=website&utm_campaign=measure',
    chatWithARep:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XBK5QAO&utm_medium=website&utm_campaign=website_nav_bar',
  },
  visualize: {
    getADemo:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000002GAbNQAW&utm_medium=website&utm_campaign=visualize_design',
    tryItNow: '/signup/professional',
    chatWithARep:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XBK5QAO&utm_medium=website&utm_campaign=website_nav_bar',
  },
};
